import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { createSelector } from 'reselect';
import Global from '../../store/global-selectors';
import * as Actions from '../../store/orders/filtering/orders.filtering.actions';
import { EditFilterViewModal } from '../../components/modals/edit-filterview-modal';
import PropType from 'prop-types';
import { useSelectedOrdersViewId } from '../../pages/orders-page/orders-left-nav/orders-left-nav-context';

const savedFilterViewsSelector = createSelector(
  (savedFilterViews) => savedFilterViews,
  (_, viewId) => viewId,
  (savedFilterViews, viewId) => {
    return savedFilterViews.filter((view) => view.gridViewId === viewId);
  },
);

export const EditOrdersFilterviewModalContainer = React.memo(({ modalFrameworkMethods }) => {
  const dispatch = useDispatch();
  const savedFilterViews = useSelector(Global.selectOrdersFilteringSavedFilterViews);
  const activeFilterView = useSelector(Global.selectOrdersFilteringActiveFilterView);
  const currentGridViewId = useSelectedOrdersViewId();
  const savedFiltersForView = savedFilterViewsSelector(savedFilterViews, currentGridViewId);
  const saveExistingFilterViewRequest = useCallback(
    (viewWithNewFilters) => {
      dispatch(Actions.saveExistingFilterViewRequest(viewWithNewFilters));
    },
    [dispatch],
  );
  const deleteViewModalAction = useCallback(() => {
    dispatch(Actions.launchDeleteViewModal());
  }, [dispatch]);

  return (
    <EditFilterViewModal
      activeFilterView={activeFilterView}
      deleteViewModalAction={deleteViewModalAction}
      modalFrameworkMethods={modalFrameworkMethods}
      savedFilterViews={savedFiltersForView}
      saveExistingFilterViewRequest={saveExistingFilterViewRequest}
    />
  );
});

EditOrdersFilterviewModalContainer.propTypes = {
  modalFrameworkMethods: PropType.shape({
    onClose: PropType.func,
  }).isRequired,
};
